
import { useFetchDomainSetupProcessQuery } from '../service';
import { useEffect, useState } from 'react';


export default function useDomainSetupProgress(domain: string) {
    const [hasActiveProcess, setHasActiveProcess] = useState<boolean>(false);
    const [processGuid, setProcessGuid] = useState<string | null>(null);

    const { data: domainSetupProcess, isLoading } = useFetchDomainSetupProcessQuery(
        { domain, processGuid },
        {
            pollingInterval: hasActiveProcess ? 5000 : 0,
            refetchOnMountOrArgChange: true,
        }
    );

    const homepageUrl = domainSetupProcess?.output?.homepage_url || null;
    const competitors = domainSetupProcess?.output?.competitors || null;
    const topKeywords = domainSetupProcess?.output?.top_keywords || null;
    const monitoringRegions = domainSetupProcess?.output?.uptime_monitoring_regions || null;
    const searchEngineMarket = domainSetupProcess?.output?.search_engine_market || null;
    const processError = domainSetupProcess?.output?.error || null;

    useEffect(() => {
        // Hasn't had a domain setup process but now there is one
        if (domainSetupProcess && hasActiveProcess === false) {
            setHasActiveProcess(true);
            setProcessGuid(domainSetupProcess.guid);
        }

        if (domainSetupProcess && domainSetupProcess.status === 'completed' && hasActiveProcess === true) {
            setHasActiveProcess(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domainSetupProcess]);

    return {
        homepageUrl: homepageUrl,
        competitors: competitors,
        topKeywords: topKeywords,
        monitoringRegions: monitoringRegions,
        searchEngineMarket: searchEngineMarket,
        processError: processError,
        isLoading
    };
}
